<template>
  <Breadcrumb />
  <SetLoader v-if="!detailRequestEnd" />
  <div class="row" v-else>
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form class="row g-3 form-custom-object-edit" novalidate>
            <div v-if="errors.length > 0" class="alert alert-warning">
              <ul class="mb-0">
                <li v-for="error in errors" v-bind:key="error">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <label for="Name" class="form-label required"
                >{{
                  $t(
                    "CustomObjects.Name",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="Name"
                v-model="customObjectData.name"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="PluralName" class="form-label required">{{
                $t(
                  "CustomObjects.PluralName",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <input
                type="text"
                class="form-control"
                id="PluralName"
                v-model="customObjectData.pluralName"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="FormulaName" class="form-label required">{{
                $t(
                  "CustomObjects.FormulaName",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}</label>
              <input
                type="text"
                class="form-control"
                id="FormulaName"
                disabled
                v-model="customObjectData.formulaName"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-md-6">
              <label
                for="RelationalRecordDeleteCustomObjects"
                class="form-label"
                >{{
                  $t(
                    "CustomObjects.RelationalRecordDeleteCustomObjects",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label
              >
              <FormSelect
                type="SelectWithRemoteDataAndInternalSearch"
                @onMultipleSelectChange="
                  onChangeRelationalRecordDeleteCustomObject
                "
                @onMultipleSelectChangeReturnValues="
                  onChangeRelationalRecordDeleteCustomObjectNames
                "
                :selectedData="selectedRelationalRecordDeleteCustomObject"
                :isParameters="true"
                :isGatewayRequest="true"
                :isMultiple="true"
                :requestUrl="
                  String.format(
                    '/Lcdp-SummaryLookupObjects?customObjectPublicId={0}',
                    this.customObjectData.publicId
                  )
                "
              />
            </div>
            <div class="col-12">
              <div class="form-check">
                <label for="IsActive" class="form-label">{{
                  $t(
                    "BaseModelFields.IsActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsActive"
                  v-model="customObjectData.isActive"
                />
              </div>
              <div class="form-check">
                <label for="IsRecordsCopied" class="form-label">{{
                  $t(
                    "CustomObjects.RecordCopiedIsActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsRecordsCopied"
                  v-model="customObjectData.isRecordsCopied"
                />
              </div>
            </div>
            <ActionButtons
              @methodSave="onSubmit('btn-save')"
              :isNewRecord="false"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "CustomObjectEdit",
  components: {},
  data() {
    return {
      submitButtonHtml: String.format(
        '<span class="loading-block"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span> {0}</span></span>',
        this.$t(
          "Buttons.PleaseWait",
          {},
          { locale: this.$store.state.activeLang }
        )
      ),
      disabledButtonClasses: ".btn-save",
      errors: [],
      customObjectData: {},
      detailRequestEnd: false,
      selectedRelationalRecordDeleteCustomObject: [],
    };
  },
  methods: {
    onChangeRelationalRecordDeleteCustomObject(value) {
      this.customObjectData.relationalRecordDeleteCustomObjectPublicIds = value;
    },
    onChangeRelationalRecordDeleteCustomObjectNames(value) {
      this.customObjectData.relationalRecordDeleteCustomObjectNames = value;
    },
    getCustomObjectDetail() {
      this.$prodGatewayAxios
        .get(
          String.format(
            "/Lcdp-CustomObjectGet?id={0}",
            this.$route.params.customObjectId
          )
        )
        .then((response) => {
          this.customObjectData = response.data;
          this.detailRequestEnd = true;

          if (
            !String.isNullOrWhiteSpace(
              this.customObjectData.relationalRecordDeleteCustomObjectNames
            ) &&
            !String.isNullOrWhiteSpace(
              this.customObjectData.relationalRecordDeleteCustomObjectPublicIds
            )
          ) {
            var relationalRecordDeleteCustomObjectPublicIds =
                this.customObjectData.relationalRecordDeleteCustomObjectPublicIds.split(
                  this.$systemSeparator
                ),
              relationalRecordDeleteCustomObjectNames =
                this.customObjectData.relationalRecordDeleteCustomObjectNames.split(
                  this.$systemSeparator
                );
            relationalRecordDeleteCustomObjectPublicIds.forEach((v, i) => {
              this.selectedRelationalRecordDeleteCustomObject.push({
                key: v,
                value: relationalRecordDeleteCustomObjectNames[i],
              });
            });
          }
        })
        .catch(function (error) {
          //alert(error);
        });
    },
    onSubmit(buttonName) {
      var form = $(".form-custom-object-edit");
      form.addClass("was-validated");
      if (!form[0].checkValidity()) {
        return;
      }

      var button = $(String.format(".{0}", buttonName)),
        firstSpan = button.find("span:first"),
        loadingBlock = button.find(".loading-block"),
        disabledButtons = $(this.disabledButtonClasses);

      disabledButtons.prop("disabled", true);
      firstSpan.hide();
      if (loadingBlock.length === 0) {
        firstSpan.after(this.submitButtonHtml);
        loadingBlock = button.find(".loading-block");
      } else {
        loadingBlock.show();
      }

      this.errors = [];
      this.$prodGatewayAxios
        .post("/Lcdp-CustomObjectUpdate", { ...this.customObjectData })
        .then((r) => {
          var response = r.data;
          if (response.isOk) {
            this.$router.push("/Customobject/Detail/" + response.publicId);
          } else {
            firstSpan.show();
            loadingBlock.hide();
            disabledButtons.prop("disabled", false);
            this.errors.push(response.msg);
          }
        })
        .catch((r) => {
          firstSpan.show();
          loadingBlock.hide();
          disabledButtons.prop("disabled", false);
          this.errors.push(r);
        });
    },
    customObjectNameKeyup: function () {
      if (String.isNullOrWhiteSpace(this.customObjectData.name)) {
        this.customObjectData.formulaName = "";
        return;
      }
      this.customObjectData.formulaName = String.replaceAlphanumeric(
        this.customObjectData.name,
        "_",
        true
      ).toUpperCase();
    },
  },
  mounted() {
    this.getCustomObjectDetail();
  },
};
</script>
